<div class="page">
  <div>
    <equipmentSheetView *ngIf="sheet_ready" [equipment]="equipment" [components]="components"></equipmentSheetView>
  </div>
</div>
